module.exports = __webpack_public_path__ + "static/media/Ooppah_Club_Parceiros.8c689420.png";